/**
 * hr_assitant/frontend/src/lib/service-registry.ts
 *
 * CRA-compatible re-export wrapper around the shared service registry.
 * CRA exposes env vars via process.env.REACT_APP_* at build time.
 *
 * Override per environment by setting these in .env.local:
 *   REACT_APP_ASSET_URL=https://asset.tscorp.ai
 *   REACT_APP_HR_URL=https://hr.tscorp.ai
 *   REACT_APP_FIN_URL=https://fin.tscorp.ai
 *   REACT_APP_LANDING_URL=https://intra.tscorp.ai
 *   REACT_APP_AUTH_URL=https://auth.tscorp.ai
 *   REACT_APP_ADMIN_URL=https://admin.tscorp.ai
 */

export const ASSET_URL   = process.env.REACT_APP_ASSET_URL   ?? 'https://asset.tscorp.ai';
export const HR_URL      = process.env.REACT_APP_HR_URL      ?? 'https://hr.tscorp.ai';
export const FIN_URL     = process.env.REACT_APP_FIN_URL     ?? 'https://fin.tscorp.ai';
export const LANDING_URL = process.env.REACT_APP_LANDING_URL ?? 'https://intra.tscorp.ai';
export const AUTH_URL    = process.env.REACT_APP_AUTH_URL    ?? 'https://auth.tscorp.ai';
export const ADMIN_URL   = process.env.REACT_APP_ADMIN_URL   ?? 'https://admin.tscorp.ai';
